import qs from 'qs';
import { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { window } from '../../../globals';
import UserStore from '../../../redux/users';
import { icons, IconText } from '../../generic/Icon';
import Link from '../../generic/Link/Link';
import Tooltip from '../../generic/Tooltip';
import type { InternalToolsOrg, OrgRequestParams } from '../../../../shared/InternalTools/orgs';
import type { User } from '../../../types';

type OrganizationActionsProps = {
  selectedOrg: InternalToolsOrg;
  orgRequestParams: OrgRequestParams;
};

const OrganizationActions: VoidFunctionComponent<OrganizationActionsProps> = ({
  selectedOrg,
  orgRequestParams,
}) => {
  const dispatch = useDispatch();

  const onChangeToOrg = useCallback(async () => {
    if (window.user) {
      dispatch(UserStore.actions.update({
        id: window.user.id,
        organizationId: selectedOrg.id,
      } as User));
      window.location.reload();
    }
  }, [dispatch, selectedOrg.id]);

  return (
    <div className="internal-tool-component">
      <h2 className="card-title">Actions</h2>
      <div className="wrapped-row">
        <Link
          to={`/api/internal-tools/orgs.csv?${qs.stringify(orgRequestParams)}`}
          className="btn btn-default"
          openInNewTab
        >
          <IconText text="Download as CSV" icon={icons.download} />
        </Link>
        <Button onClick={onChangeToOrg}>
          Change App to {selectedOrg.title}
        </Button>
        <Tooltip
          tooltip="If you need to delete an organization, please submit a request to engineering"
        >
          <span>
            <Button bsStyle="danger" disabled>
              Delete
            </Button>
          </span>
        </Tooltip>
      </div>
    </div>
  );
};

export default OrganizationActions;
